import React  from "react";
import { Navigate } from "react-router-dom";
import authService from "../Authentication/authService";
const clientName = process.env.REACT_APP_CLIENT_NAME || ""; 

// returns to the repective page based on the roles
function ProtectedRoute({ children, roles, ...rest }) {

  if (authService.isAuthenticateduser()) {
    const userRoles = authService.getCurrentUserRole();
    
    if (
      (roles !== undefined || roles !== null || roles !== "") &&
      userRoles !== null
    ) {
      if (roles.includes(userRoles) && authService.isAuthenticateduser()) {
        return children;
      } else {
        return <Navigate to= {clientName !== "Forum" ? `/${clientName}/Login` : "/Login"} replace />;
      }
    } else {
      return <Navigate to= {clientName !== "Forum" ? `/${clientName}/Login` : "/Login"}  replace />;
    }
  } else {
    return <Navigate to= {clientName !== "Forum" ? `/${clientName}/Login` : "/Login"}  replace />;
  }
}

export default ProtectedRoute;
